<div class="bg-white p-4  rounded-lg shadow-md">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
        <div>
            <label class="text-[#21252A] font-roboto text-[19.797px] font-bold leading-[19.637px]">REQUEST</label>
            <div class="mt-2">
                <p class="font-medium text-[16px] text-[#21252A]">Subject *</p>
                <p class="font-medium text-[14px] text-[#21252A]">RFI-001 - Clarification on Design Layout</p>
            </div>
            <div class="mt-4 ">
                <p class="font-medium text-[16px] text-[#21252A]">Question *</p>
                <p class="text-[16px] font-normal roboto">Could you please provide clarification regarding the alignment of the sidebar elements in the dashboard design? We are unsure if the icons should be centered or aligned to the left.</p>
            </div>
        </div>
        <div class="ml-4  flex justify-center ">
            <div>
                <label class="!font-medium !text-[1rem] ">Attachments</label>
                <div class="mt-2">
                    <div class="flex items-center mb-2">
                        <mat-icon class="text-blue-600">description</mat-icon>
    
                        <a href="#" class="text-[#000000] !text-[14px] ">Project_Proposal.doc</a>
                    </div>
                    <div class="flex items-center">
                        <mat-icon class="text-blue-600">description</mat-icon>
    
                        <a href="#" class="text-[#000000] !text-[14px] ">Project_Proposal.doc</a>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</div>
